import { render, staticRenderFns } from "./userInvestmentsFlow.vue?vue&type=template&id=2db99a9c&scoped=true"
import script from "./userInvestmentsFlow.js?vue&type=script&lang=js&external"
export * from "./userInvestmentsFlow.js?vue&type=script&lang=js&external"
import style0 from "./userInvestmentsFlow.css?vue&type=style&index=0&id=2db99a9c&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db99a9c",
  null
  
)

export default component.exports